import React from "react";
import styled, { withTheme } from "styled-components";

const MktoWrapper = styled.div`
  .mktoForm {
    .mktoFormRow {
      margin: 0 !important;
      .mktoFieldWrap {
        .mktoField {
          width: 80% !important;
        }
        .mktoLabel {
          width: 20% !important;
        }
      }
    }
    .mktoButtonRow {
      width: 100%;
      .mktoButtonWrap {
        margin: 0 0 0 120px !important;
      }
    }
  }
`;

const MarketoSingleEmailFieldStyle = ({ children }) => (
  <MktoWrapper>{children}</MktoWrapper>
);

export default withTheme(MarketoSingleEmailFieldStyle);
